import { filter, omitBy, uniqBy, without } from 'lodash';
import { ACTION_TYPES as PROJECTS_ACTION_TYPES } from '../redux/projects/constants';
import { ACTION_TYPES as SECTION_ACTION_TYPES } from '../redux/sections/constants';

const data = {
  myProjects: [],
  getProjects: { title: '', sections: [] },
  publicTemplates: [],
  projectCustomFields: [],
  loading: false,
  isLoaded: false,
};

const updateProjectRoleInState = (project, projectId, roles) => {
  if (project?._id?.toString() !== projectId?.toString()) {
    return;
  }

  for (let r of roles) {
    const uIndex = project?.participants?.findIndex(
      (p) => p?._id?.toString() === r?.userId?.toString(),
    );
    if (uIndex > -1) {
      project.participants[uIndex].role = r?.role;
    }
  }
};

const projectReducer = (state = data, action) => {
  switch (action.type) {
    case 'project-success':
      return {
        ...state,
        success: action.payload,
      };

    case 'project-error':
      return {
        ...state,
        error: action.payload,
      };

    case 'projects-loading':
    case 'dashboard-loading':
      return {
        ...state,
        loading: action.payload,
      };

    case 'get-projects':
      return {
        ...state,
        getProjects: action.payload,
      };

    case 'updateRolesInProject':
      const selectedPrj = { ...state?.getProjects };
      updateProjectRoleInState(
        selectedPrj,
        action?.payload?.projectId,
        action?.payload?.users,
      );
      return {
        ...state,
        getProjects: selectedPrj,
      };

    case 'set-project-custom-fields':
      return {
        ...state,
        projectCustomFields: action.payload,
      };

    case 'set-project-templates':
      return {
        ...state,
        publicTemplates: action.payload,
      };

    case 'pre-section-update':
      return {
        ...state,
        getProjects: action.payload,
      };

    case 'unset-active-project':
      return {
        ...state,
        success: null,
      };

    case 'toggle-pin-item':
      if (action.payload?.data?.entityType == 'project') {
        return {
          ...state,
          getProjects: {
            ...state.getProjects,
            pinned: action.payload?.isPinned,
          },
          myProjects: state.myProjects.map((p) => {
            if (p == action.payload?.data?.entityId) {
              return { ...p, pinned: action.payload?.isPinned };
            }
            return p;
          }),
        };
      }

      return {
        ...state,
      };

    case 'update-section-count':
      const { from, to, taskId, projectId } = action.payload;
      const project = state?.getProjects;
      if (projectId?.toString() !== project?._id?.toString()) {
        return state;
      }

      for (let section of project?.sections) {
        if (section?._id?.toString() === from?.toString()) {
          const fromTasks = section?.tasks || [];
          section.tasks =
            fromTasks.filter((tsk) => tsk?.toString() !== taskId?.toString()) ||
            [];
        } else if (section?._id?.toString() === to?.toString()) {
          const toTasks = section?.tasks || [];
          const isExisting = toTasks?.find(
            (tsk) => tsk?.toString() === taskId?.toString(),
          );
          if (!isExisting) {
            toTasks.push(taskId);
            section.tasks = toTasks;
          }
        }
      }

      return {
        ...state,
        getProjects: project,
      };

    case 'update-project-sections':
      if (
        action.payload?.projectId?.toString() !==
        state?.getProjects?._id?.toString()
      ) {
        return state;
      }

      const updatedProject = { ...state.getProjects };
      updatedProject.sections = action.payload?.sections;

      return {
        ...state,
        getProjects: updatedProject,
      };

    case PROJECTS_ACTION_TYPES.GET_USER_PROJECTS_REQUEST_SUCCESS: // 'get-users-projects':
      return {
        ...state,
        isLoaded: true,
        myProjects: action?.payload?.map((project) => {
          const userId = localStorage.getItem('Id');
          if (project?.participants?.find((member) => member?._id == userId)) {
            return project;
          }

          return;
        }),
      };

    case PROJECTS_ACTION_TYPES.UPDATE_PROJECT_REQUEST_SUCCESS: //'project-update-success':
      const updatedProjects = state.myProjects.map((project) => {
        if (project?._id == action?.payload?._id) {
          return {
            ...project,
            ...action?.payload,
            sections: project?.sections || action?.payload?.sections,
            participants: project?.participants || action?.payload?.participants,
          };
        }
        return project;
      });
      const updatedGetProject =
        state.getProjects && state.getProjects._id === action?.payload?._id
          ? {
              ...state.getProjects,
              ...action.payload,
              sections: state.getProjects?.sections || action.payload?.sections,
              participants: state.getProjects?.participants || action.payload?.participants,
            }
          : state.getProjects;
      return {
        ...state,
        myProjects: updatedProjects,
        getProjects: updatedGetProject,
      };

    case 'delete-project':
      const deletedProjects = state.myProjects.filter(
        (proj) => proj._id !== action.payload,
      );
      return {
        ...state,
        myProjects: deletedProjects,
        getProjects:
          state.getProjects?._id === action.payload
            ? data.getProjects
            : state.getProjects,
      };

    case 'restore-project':
      return {
        ...state,
        myProjects: [action.payload, ...state.myProjects],
      };

    case 'update-pin-project': {
      const { data, isPinned } = action.payload;
      const currentProjects = state.myProjects || [];

      let updatedMyProjects;

      if (!isPinned) {
        updatedMyProjects = currentProjects.map((item) =>
          item._id === data.entityId ? { ...item, pinned: false } : item,
        );
      } else {
        updatedMyProjects = currentProjects.map((item) =>
          item._id === data.entityId ? { ...item, pinned: true } : item,
        );
      }

      return {
        ...state,
        myProjects: updatedMyProjects,
      };
    }

    case PROJECTS_ACTION_TYPES.ADD_PROJECT_REQUEST_SUCCESS: {
      // 'add-project':
      const projectId = action?.payload?._id;

      const alreadyHasInState =
        (state.myProjects || []).findIndex(
          (project) => project?._id === projectId,
        ) > -1;

      if (alreadyHasInState) {
        return state;
      }

      return {
        ...state,
        myProjects: [action.payload, ...state.myProjects],
      };
    }

    case PROJECTS_ACTION_TYPES.DELETE_CUSTOM_FIELD_FROM_PROJECT: {
      return {
        ...state,
        projectCustomFields: state.projectCustomFields.filter(
          (cf) => cf._id !== action.payload.customFieldId,
        ),
      };
    }
    case SECTION_ACTION_TYPES.ADD_SECTION_REQUEST_SUCCESS: {
      return {
        ...state,
        getProjects: {
          ...(state?.getProjects || {}),
          sections: uniqBy(
            [...(state?.getProjects?.sections || []), action?.payload],
            (section) => section?._id,
          ),
        },
      };
    }
    case SECTION_ACTION_TYPES.REMOVE_SECTION_SUCCESS: {
      return {
        ...state,
        getProjects: {
          ...(state?.getProjects || {}),
          sections: filter(state?.getProjects?.sections || [], section => section?._id !== action?.payload),
        },
      };
    }

    default:
      return state;
  }
};
export default projectReducer;
